import { MainPage } from "@c/MainPage";
import { ConditionallyRender } from "@gazebo/nextjs";
import { eventToRelativeCoordinates } from "@gazebo/utils/eventToRelativeCoordinates";
import { observer } from "mobx-react-lite";
import type { NextPage } from "next";
import React, { MouseEventHandler, useCallback, useEffect, useRef, useState } from "react";

const Space: React.FC<{}> = () => {
    // data
    const [data, setData] = useState([{ x: 100, y: 50, title: "helloword", _id: 'helloworld' }])

    const addData = useCallback(({ x, y }: { x: number, y: number }) => {
        setData(xs => [...xs, { x, y, title: `helloworld ${xs.length}`, _id: Date.now().toString() }])
    }, [setData])

    // clicks & interactions
    const [current, setCurrent] = useState<{ x: number, y: number, double: boolean } | null>(null)
    const ref = useRef<HTMLDivElement>(null)

    const [clicked, setClicked] = useState(false)
    const [lastEvent, setLastEvent] = useState<null | React.MouseEvent>(null)

    const onSimpleClick = useCallback((e: MouseEvent) => {
        const xy = eventToRelativeCoordinates(e, ref.current!)
        setCurrent({ ...xy, double: false })
    }, [setCurrent, ref])

    const onDoubleClick = useCallback((e: MouseEvent) => {
        const xy = eventToRelativeCoordinates(e, ref.current!)
        setCurrent({ ...xy, double: true })
        addData(xy)
    }, [setCurrent, ref])

    const onClick: MouseEventHandler<HTMLDivElement> = useCallback((e) => {
        setLastEvent(e)

        if (clicked) {
            // @ts-ignore: TODO: fixme
            onDoubleClick(e)
            setClicked(false)
        } else {
            setClicked(true)
        }
    }, [setLastEvent, setClicked, clicked, onDoubleClick])


    useEffect(() => {
        if (clicked && lastEvent) {
            const r = setTimeout(() => {
                // @ts-ignore: TODO: fixme
                onSimpleClick(lastEvent)
                setClicked(false)
                setLastEvent(null)
            }, 150)

            return () => clearTimeout(r)
        }
    }, [lastEvent, clicked, setClicked, setLastEvent])

    return (<div ref={ref} style={{
        position: 'relative', width: '100% ', height: '94vh', backgroundColor: '#DDDDDD'
    }} onClick={onClick}>
        {current &&
            <div style={{ width: '10px', height: '10px', backgroundColor: current.double ? 'blue' : 'red', position: 'absolute', top: current.y, left: current.x }}></div>
        }
        {data.map(x => (
            <div key={x._id} style={{ position: 'absolute', left: x.x, top: x.y }}>
                {x.title}
            </div>
        ))}


    </div >)
}

const Page: NextPage = observer(() => {
    return (
        <MainPage isEditor>
            <main className="container is-widescreen fullscreen fullheight">
                <ConditionallyRender client>
                    <Space />
                </ConditionallyRender>
            </main>
        </MainPage >
    );
});

export default Page;
